import moment from "@/utils/moment";

export default {
  filters: {
    intToTime(number, format = "HH:mm:ss") {
      return number
        ? moment()
            .set({
              hour: number,
              minute: 0,
              second: 0,
              millisecond: 0
            })
            .format(format)
            .toString()
        : null;
    },

    secondsToHours(seconds) {
      let res = seconds / 60;
      return res + "h";
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/timeMixin.js